import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AuthService } from '../../../authentication/services/auth.service';
import { Router } from '@angular/router';
import { ProfileService } from '../../../services/profile.service';

@Component({
  selector: 'nt-dialog-sing',
  templateUrl: './dialog-sing.component.html',
  styleUrl: './dialog-sing.component.scss',
  imports: [MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})


export class DialogSingComponent {
  readonly dialog = inject(MatDialog);
  readonly profileService = inject(ProfileService);
  private readonly _authService = inject(AuthService);
  private readonly _router: Router = inject(Router);
  accept() {
    this.profileService.saveTerms().subscribe();
  }
  cancel() {
    this._authService.logout();
    this._router.navigateByUrl('/login');
  }
}

@Component({
  selector: 'nt-dialog-content-sing',
  templateUrl: './dialog-sing.component.html',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
})
export class DialogContentDialogSingComponent {
  accept() {
  }
  cancel() {
  }
}